import { useI18N } from "@sundae/react-hooks";
import { useWallet } from "@sundae/wallet-react";
import { useCallback, useState } from "react";
import { Actions, useAppContext } from "../stores/index.js";
export const useWalletConnectFlow = () => {
    const { t } = useI18N("wallet");
    const { dispatch, state: { walletConnectOpen }, } = useAppContext();
    const { connectWallet, isConnectingWallet } = useWallet();
    const [error, setError] = useState("");
    const handleCloseWalletConnectDialog = useCallback(() => {
        Actions.setConnectWalletOpen(false, dispatch);
    }, []);
    const handleConnect = useCallback(async (id) => {
        try {
            await connectWallet(id);
            handleCloseWalletConnectDialog();
        }
        catch (err) {
            const error = err;
            if (error?.message && error?.message === "no account set") {
                setError(t("error.no_account"));
            }
        }
    }, []);
    return {
        error,
        handleCloseWalletConnectDialog,
        handleConnect,
        isConnectingWallet,
        walletConnectOpen,
    };
};
//# sourceMappingURL=useWalletConnectFlow.js.map